import FunnelRetentionModule from "./funnelRetentionModule";
import FunnelRetentionSaga from "./redux/retentionSagas";
import FunnelRetentionReducer from "./redux/retentionReducer";

export default {
  Component: FunnelRetentionModule,
  moduleName: "funnelRetention",
  saga: FunnelRetentionSaga(),
  reducer: FunnelRetentionReducer
};
